"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseMessage = void 0;
var parseMessage = function (message) {
    var pubSubMessage = message;
    var decoded = Buffer.from(pubSubMessage.data, 'base64').toString().trim();
    var o = JSON.parse(decoded);
    return o;
};
exports.parseMessage = parseMessage;
